// extracted by mini-css-extract-plugin
export default {"wrapper":"AddBuildingModal_wrapper__VeNuT","content":"AddBuildingModal_content__kiitp","name":"AddBuildingModal_name__+xc-8","btn":"AddBuildingModal_btn__HsokJ"};